import styled, { css } from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';
import { hexToRGB } from '@repo-level/core-front';
import { ScButton } from 'components/buttons/Button/styled';
import {
  ScCheckboxBlock,
  ScOptions,
  ScSelectBlock,
  ScSelectButton,
} from 'components/form/primitives/styled';

interface IScWrapperPromoProps {
  userBonuses?: boolean;
}

interface IScDepositRowProps {
  isPadding: boolean;
}

interface IScDepositContentProps {
  isCryptoMethod: boolean;
}

interface IScPaymentMethodCompWrapperProps {
  isDeposit: boolean;
}

export const ScDepositModal = styled.div`
  font-family: ${({ theme }) => theme.mainFontFamily};
  position: relative;
  background: ${({ theme }) => theme.secondaryColor3};
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 768px;
  margin: 40px auto;
  @media (${device.mobile}) {
    margin: 16px auto;
  }
`;

export const ScDepositWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (${device.mobileS}) {
    gap: 8px;
  }
`;

export const ScDepositTitle = styled.div`
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0.22px;
  text-transform: capitalize;
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
  @media (${device.mobileS}) {
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.18px;
  }
`;

export const ScDepositRow = styled.div<IScDepositRowProps>`
  display: grid;
  grid-template-columns: 305px auto;
  gap: 16px;

  ${({ isPadding }) =>
    isPadding &&
    css`
      @media (${device.mobileS}) {
        padding-bottom: 95px;
      }
    `}

  @media (${device.mobile}) {
    display: block;
  }
`;

export const ScDepositNav = styled.div`
  padding: 16px;
  border-right: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
  background-color: ${({ theme }) => theme.grayColor8};
  border-radius: 12px;
  height: fit-content;
  @media (${device.mobile}) {
    padding: 12px 16px;
  }
  @media (min-width: 360px) and (max-width: 380px) {
    padding: 10px;
  }
  .payment-method {
    display: none;
    @media (${device.mobile}) {
      display: flex;
      align-self: start;
      color: ${({ theme }) => theme.whiteColor};
    }
  }
  .currency-payments {
    @media (${device.mobile}) {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      gap: 16px;
      align-items: end;
    }
    @media (min-width: 360px) and (max-width: 380px) {
      display: flex;
      gap: 8px;
    }
  }
  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 8px;
    border-right: none;
  }
`;

export const ScDepositContent = styled.div<IScDepositContentProps>`
  word-break: break-word;

  .deposit-wrapper {
    display: flex;
    flex-direction: column;
    z-index: 1;
    @media (${device.mobileS}) {
      position: ${({ isCryptoMethod }) =>
        isCryptoMethod ? 'relative' : 'fixed'};
      bottom: 0px;
      z-index: 9999;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      max-width: calc(100% - 210px);
      background: ${({ theme }) => theme.darkGradient};
      box-shadow: 0 0 0 100vmax ${({ theme }) => theme.darkGradient};
      clip-path: inset(-12px -100vmax);
      .deposit-button {
        padding: 0 16px;
      }
    }
    @media (${device.mobileS}) {
      max-width: calc(100% - 24px);
    }
  }

  .deposit-button {
    button {
      margin-top: 16px;
    }
  }

  .help-wrapper {
    margin-top: 16px;
    display: flex;
    gap: 4px;
    justify-content: center;
    span {
      color: ${({ theme }) => theme.greenColor};
      cursor: pointer;
      transition: color 0.3s ease;
    }
    @media (hover: hover) {
      span:hover {
        color: ${({ theme }) => hexToRGB(theme.greenColor, 0.6)};
      }
    }
    @media (${device.mobileS}) {
      margin: 16px 0;
    }
  }
`;

export const ScPaymentMethodCompWrapper = styled.div<IScPaymentMethodCompWrapperProps>`
  ${({ isDeposit }) =>
    isDeposit &&
    css`
      background-color: ${({ theme }) => theme.grayColor8};
      padding: 16px;
      border-radius: 12px;
      @media (${device.mobile}) {
        padding: 12px 16px;
        margin-top: 12px;
      }
    `};
`;

export const ScWrapperPromo = styled.div<IScWrapperPromoProps>`
  background-color: ${({ theme }) => theme.grayColor8};
  border-radius: 12px;
  padding: 16px;
  height: fit-content;
  margin-top: 16px;
  @media (${device.mobile}) {
    padding: 12px 16px;
    margin-top: 12px;
  }
  .title {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.16px;
    font-weight: 700;
    color: ${({ theme }) => theme.whiteColor};
  }
  ${({ userBonuses }) =>
    userBonuses &&
    css`
      ${ScCheckboxBlock} {
        margin-top: 16px;
      }
    `}
`;

export const ScCurrencyUser = styled.div`
  padding: 16px;
  margin: -16px -16px 0 -16px;
  @media (${device.mobile}) {
    padding: 0;
    margin: 0;
  }

  .select-wallet {
    @media (${device.mobile}) {
      width: 108px;
    }
  }

  h3 {
    font-size: 14px;
    text-transform: capitalize;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.whiteColor};
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.16px;
    @media (${device.mobile}) {
      display: none;
    }
  }
  ${ScButton} {
    background-color: ${({ theme }) => theme.grayColor9};
    margin: 8px 0 8px 0;

    .btn-content {
      color: white;
    }
  }
`;

export const ScPaymentsMethods = styled.div`
  padding: 8px 16px 0 16px;
  margin: 0 -16px 0 -16px;
  color: ${({ theme }) => theme.whiteColor};
  @media (${device.mobile}) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .crypto-title {
    margin-top: 16px;
  }
  @media (${device.mobile}) {
    padding-bottom: 0;
  }
  ${ScSelectBlock} {
    .custom-label {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .limits-wrapper {
      .limits {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
    ${ScOptions} {
      .options-list {
        li {
          &:not(.active) {
            div {
              color: ${({ theme }) => theme.grayColor1};
            }
          }
          &.active {
            div {
              color: ${({ theme }) => theme.whiteColor};
            }
          }
        }
      }
    }
    .limits {
      padding-right: 8px;
      font-weight: 400;
    }
    .options-list {
      gap: 4px;
      padding: 8px 0 8px 0;
      .active {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
    .options-list li.active {
      color: ${({ theme }) => theme.whiteColor};
    }
    .options-list > li {
      padding: 0;
    }
    .options-list ul li {
      padding: 2px;
    }
    .value {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    ${ScSelectButton} {
      padding: 0 16px 0 8px;
    }
  }
  & .title {
    display: none;
    @media (${device.mobile}) {
      display: block;
    }
  }
  h3 {
    font-size: 16px;
    line-height: 28px;
    font-weight: 700;
    letter-spacing: 0.16px;
    text-transform: none;
    margin-bottom: 16px;
  }

  .button-wrapper {
    position: relative;
    width: 100%;
    max-width: 132px;
    height: 100%;
    overflow: hidden;
    border-radius: 4px;
    z-index: 1;
    .limits-wrapper {
      display: flex;
      justify-content: center;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0px;

      .limits {
        display: flex;
        gap: 3px;
      }
    }
  }

  .payments {
    display: grid;
    grid-template-columns: repeat(2, 132px);
    gap: 8px;
    position: relative;
    button {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 12px;
      background: ${({ theme }) => theme.whiteColor};
      border: ${({ theme }) => `2px solid ${theme.whiteColor}`};
      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: ${({ theme }) => theme.grayColor2};
        opacity: 0.6;
        z-index: 1;
        transition: opacity 0.3s;
        height: 56px;
        border-radius: 12px;
      }

      &.active::before {
        opacity: 0;
      }

      &:hover::before {
        opacity: 0;
      }

      cursor: pointer;
      height: 56px;
      transition: 0.3s;
      &:hover {
        background: ${({ theme }) => theme.whiteColor};
      }
      &.active {
        border: ${({ theme }) => `2px solid ${theme.greenColor}`};
        background: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;

export const ScNotFound = styled.div`
  padding: 16px 24px;
  border: 1px solid transparent;
  border-radius: 8px;

  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
`;
